import BaseService from "./base.service";

export default class BannersService extends BaseService {
	constructor() {
		super("banners");
	}
}
